import DummyApiProvider from '@/services/api/providers/DummyApiProvider'
import RestApiProvider from '@/services/api/providers/RestApiProvider'
import { BaseDateIndentConvertor } from '@/services/dateConvertor/BaseDateIndentConvertor'

export default () => {
  return process.env.VUE_APP_ENABLE_DUMMY_API
    ? new DummyApiProvider()
    : new RestApiProvider(new BaseDateIndentConvertor())
}
